import {RemoteGetProceduresList} from 'data/usecases/private/my-hospitalization/remote-get-procedures-list';
import {GetProceduresList} from 'domain/usecases/private/my-hospitalization/get-procedures-list';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {makeBFFApiUrl} from 'main/factories/http';
import {MyHospitalizationEndpoints} from 'main/factories/usecases/endpoints';

export const makeGetProceduresList = (): GetProceduresList =>
	new RemoteGetProceduresList(
		makeBFFApiUrl(MyHospitalizationEndpoints.proceduresList),
		makeAuthorizeHttpClientDecorator(),
	);
